<template>
  <div>
    <l-tables :tableConfig="tableConfig" ref="childRef" :searchParams='searchData'  :noCreatText="$t('admin.comment.noData')"  :ImgSrc='nullImg' @tableChange="handleTableHeaderChange">
      <template slot="searchConditions">
        <a-input v-model="keyword" @change="search" maxlength="30" :placeholder="$t('admin.comment.placeholder')">
          <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
          <img class="clear" v-if="keyword" slot="suffix" @click="keyword = undefined, search()" :src="require('@/assets/icons/icon_gb.png')" />
        </a-input>
      </template>
      <template slot="searchTime">
        <a-range-picker @change="onChange">
          <a-icon slot="suffixIcon" style='color: rgb(125 133 147)' type="down" />
        </a-range-picker>
      </template>
      <template #resUrl="{ record }">
        <a-tooltip placement="bottom">
          <template slot="title">
            <div>{{ record.resUrl }}</div>
          </template>
          <div class='overF'>{{ record.resUrl }}</div>
        </a-tooltip>
      </template>
      <template #content="{ record }">
        <a-tooltip placement="bottom" overlayClassName="draw_atooltip">
          <template slot="title">
            <div v-html="record.content"></div>
          </template>
          <div class='overF' v-html="record.content"></div>
        </a-tooltip>
      </template>

      <!--      创建时间-->
      <!--      <a-icon-->
      <!--        slot="filterIcons"-->
      <!--        slot-scope="filtered"-->
      <!--        type="calendar"-->
      <!--        :style="{ color:  filterIconsState ? '#FFA000' : undefined }"-->
      <!--      />-->
      <template #operates="{ record }">
        <div class="operate">

          <span type="link" v-if='record.status==1' style="padding-right: 0" @click="optionClick(record)">
            {{ $t('admin.comment.actions.offline') }}
          </span>
          <span type="link" v-else style="padding-right: 0;color: #2DB58B" @click="optionClick(record)">
            {{ $t('admin.comment.actions.online') }}
          </span>
          <span type="link"   @click="deleteClick(record.id)">
            {{ $t('admin.comment.actions.delete') }}
          </span>
        </div>
      </template>
    </l-tables>
  </div>
</template>

<script>
import LTables from '@/components/LTables/index.vue'
import {
  postCommentStatusOff, postCommentStatusOn,
} from '@/api/admin'
let att = []
export default {
  components: {
    LTables
  },
  data() {
    return {
      nullImg:require('@/assets/img/bj_zanwushujv.png'),
      keyword: undefined,
      searchData:{
        keyword:''
      },
      tableConfig: {
        tableName: this.$t('admin.comment.title'),
        tableColumns: [
          {
            title: this.$t('admin.comment.columns.index'),
            dataIndex: 'index',
            key: 'index',
            align: 'center',
            width: 80,
          },
          {
            title: this.$t('admin.comment.columns.role'),
            dataIndex: 'roleName',
            key: 'roleName',
            align: 'center',
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filters: [
              { text: this.$t('admin.comment.roles.admin'), value: 'admin' },
              { text: this.$t('admin.comment.roles.teacher'), value: 'teacher' },
              { text: this.$t('admin.comment.roles.student'), value: 'student' },
            ],
          },
          {
            title: this.$t('admin.comment.columns.user'),
            dataIndex: 'userName',
            key: 'userName',
            align: 'center',
          },
          {
            title: this.$t('admin.comment.columns.resourceType'),
            dataIndex: 'resTypeName',
            key: 'resTypeName',
            align: 'center',
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filters: [
              { text: this.$t('admin.comment.resourceTypes.model'), value: 'model' },
              { text: this.$t('admin.comment.resourceTypes.software'), value: 'software' },
              { text: this.$t('admin.comment.resourceTypes.text'), value: 'text' },
              { text: this.$t('admin.comment.resourceTypes.image'), value: 'image' },
              { text: this.$t('admin.comment.resourceTypes.video'), value: 'video' },
              { text: this.$t('admin.comment.resourceTypes.audio'), value: 'audio' }
            ],
          },
          {
            title: this.$t('admin.comment.columns.resourceTitle'),
            dataIndex: 'resName',
            key: 'resName',
            align: 'center',
          },
          {
            title: this.$t('admin.comment.columns.resourceUrl'),
            dataIndex: 'resUrl',
            key: 'resUrl',
            align: 'center',
            scopedSlots: { customRender: 'resUrl' }
          },
          {
            title: this.$t('admin.comment.columns.content'),
            dataIndex: 'content',
            key: 'content',
            align: 'center',
            scopedSlots: { customRender: 'content' }
          },
          {
            title: this.$t('admin.comment.columns.likes'),
            dataIndex: 'likesCount',
            key: 'likesCount',
            align: 'center',
          },
          {
            title: this.$t('admin.comment.columns.commentTime'),
            dataIndex: 'commentTime',
            key: 'commentTime',
            align: 'center',
            sortDirections: ["descend", "ascend","descend"],
            sorter: true,
          },
          {
            title: '操作',
            dataIndex: 'operate',
            key: 'operate',
            align: 'center',
            scopedSlots: { customRender: 'operates' }
          }
        ],
        tableDeleteTip: {
          title: this.$t('admin.comment.deleteConfirm.title'),
          content: this.$t('admin.comment.deleteConfirm.content')
        },
        tablePort: {
          list: '/admin/comment/list',
          del: '/admin/comment/delete'
        },
      },
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      roomList:[],
      teachList:[],
      filterResult:{},
      filterTime:{},
      filterIconsState:false,
      filterIconState:false,

    }
  },
  mounted() {
  },
  methods: {
    search() {
      this.searchData.keyword = this.keyword
    },
    create() {
      this.$router.push({
        name: 'teacherAdd'
      })
    },
    // 上下架
    optionClick(item){
      console.log(item)
      if(item.status==1){
        postCommentStatusOff({
          id:item.id,
        }).then(res=>{
          if(res.code==200){
            this.$refs.childRef.getList()
            this.$message.success(this.$t('admin.comment.messages.offlineSuccess'))
          }
        })
      }else{
        postCommentStatusOn({
          id:item.id,
        }).then(res=>{
          if(res.code==200){
            this.$refs.childRef.getList()
            this.$message.success(this.$t('admin.comment.messages.onlineSuccess'))
          }
        })
      }
    },
    deleteClick(id){
      console.log(id)
      this.$refs.childRef.delModal(id)
    },
    onChange(value, dateString) {
      console.log(dateString)
      if(dateString!==''){
        this.filterTime={
          startTime:dateString[0],
          endTime:dateString[1]
        }
      }else{
        this.filterTime={
          startTime:'',
          endTime:''
        }
        delete  this.filterResult.filterTime;
      }
      let param = {...this.filterResult,...this.filterTime}
      this.$refs.childRef.getList({condition:param});
    },
    onOk(value) {
      console.log('onOk: ', value);
    },
    handleTableHeaderChange([filters,getList,sorter]) {
      let timeSort={}
      // 升序
      if(sorter.order === 'ascend'){
        timeSort.timeOrder = 'asc'
        // 倒序
      }else if(sorter.order === 'descend'){
        timeSort.timeOrder = 'desc '
      }

      const result = {...timeSort,...{role:filters.roleName},...{resType:filters.resTypeName},...this.filterTime}
      this.filterResult = result
      getList({condition:result})
    },
  }
}
</script>

<style lang="less" scoped>
.l-form {
  /deep/ .ant-form-item {
    margin-bottom: 0 !important;
    width: 250px;
    line-height: 30px;
  }
  .ant-form-item-label {
    margin-top: 10px;
  }
}
/deep/ .ant-table-thead > tr > th .anticon-filter, .ant-table-thead > tr > th .ant-table-filter-icon{
  right: auto !important;
}
.remark_cla{
  max-width: 200px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
/deep/.ant-modal-wrap .ant-modal .ant-input {
  resize: none; /* 禁止用户手动拖动调整大小 */
}
/deep/ .ant-table-filter-dropdown .ant-dropdown-menu{
  max-height: 319px !important;
  overflow-x: auto !important;
}
.marginBottom0{
  margin-bottom: 0;
}
/deep/ .ant-form-item-children{
  textarea{
    width: 100% !important;
  }
}
.operate{
  margin-right: 21px;
  display: flex;
  justify-content: center;
  >span{
    display: inline-block;
    white-space: nowrap;
  }
}
.overF{
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 auto;
  height: 29px;
  line-height: 34px;
}
/deep/ .ant-table-thead > tr > th .anticon-filter, .ant-table-thead > tr > th .ant-table-filter-icon{
  right: auto !important;
  line-height: 20px;
}
</style>
<style lang="less">
.draw_atooltip{
  .ant-tooltip-inner{
    max-height: 210px !important;
    overflow: auto !important;
  }
  .ant-tooltip{
    max-height: 210px !important;
    overflow: auto !important;
  }
}
</style>
